export default "__VITE_ASSET__BwsygCXK__"